import Api from '@/services/Api'
const URL = 'cat/hablador-lista/';

export default {

    /**
     * Listas no anuladas de la tienda, con conteo de productos.
     * @param {String} tienda codigo de tienda
     * @param {Boolean} loading muestra la barra de carga
     */
    listar(tienda, loading = true) {
        return Api(loading).get(URL, {
            params: {
                tienda: tienda,
                quitar_paginacion: true,
            }
        })
    },

    /**
     * Crea una lista nueva (abierta).
     * @param {String} tienda codigo de tienda
     */
    crear(tienda) {
        return Api().post(URL, {
            tienda: tienda,
        })
    },

    /**
     * Encabezado y lineas activas de una lista.
     * @param {String} id id de la lista
     */
    detalle(id, loading = true) {
        return Api(loading).get(`${URL}${id}/detalle/`);
    },

    /**
     * Agrega un producto por SKU o codigo de barras a una lista abierta.
     * @param {String} id id de la lista
     * @param {String} codigo SKU o barra escaneada
     */
    agregar(id, codigo) {
        return Api(false).post(`${URL}${id}/agregar/`, {
            codigo: codigo,
        })
    },

    /**
     * Quita (anula) una linea de una lista abierta.
     * @param {String} id id de la lista
     * @param {String} detalle id de la linea
     */
    quitar(id, detalle) {
        return Api().post(`${URL}${id}/quitar/`, {
            detalle: detalle,
        });
    },

    /**
     * Cierra la lista: ya no admite productos y se puede imprimir.
     * @param {String} id id de la lista
     */
    cerrar(id) {
        return Api().post(`${URL}${id}/cerrar/`);
    },

    /**
     * Reabre una lista cerrada para agregar productos.
     * @param {String} id id de la lista
     */
    reabrir(id) {
        return Api().post(`${URL}${id}/reabrir/`);
    },

    /**
     * Anula la lista completa.
     * @param {String} id id de la lista
     */
    anular(id) {
        return Api().post(`${URL}${id}/anular/`);
    },

    /**
     * Registra que unas lineas de una lista cerrada se enviaron a imprimir.
     * @param {String} id id de la lista
     * @param {Array} ids ids de las lineas
     */
    marcar_impreso(id, ids) {
        return Api(false).post(`${URL}${id}/marcar_impreso/`, {
            ids: ids,
        });
    },

}
